import $api from "..";
import { AxiosResponse } from "axios";
import type { IGetTaskData } from "../common/api_interfaces/statistics/IGetTaskData";
import type { IStatisticsRequest } from "../common/api_interfaces/statistics/IStatisticsRequest";
import type { IPieChartPart } from "../common/api_interfaces/statistics/IPieChartPart";
import type  { IOverdueTask } from "../common/api_interfaces/statistics/IOverdueTask";
import type  { IBurn } from "../common/api_interfaces/statistics/IBurn";
import { IProjectProgressInfo } from "../common/api_interfaces/project/IProjectProgressInfo";
import { IGetStatisticsData } from "../common/api_interfaces/project/IGetStatisticsData";

export default class StatisticsService {
    static async getBurndown(body: IStatisticsRequest): Promise<AxiosResponse<IBurn[]>> {
        return $api.post<IBurn[]>('/statistics/getBurnDown', body);
    }
    static async getBurnup(body: IStatisticsRequest): Promise<AxiosResponse<IBurn[]>> {
        return $api.post<IBurn[]>('/statistics/getBurnUp', body);
    }
    static async reportGetOverdueTasks(body: IStatisticsRequest): Promise<AxiosResponse<IOverdueTask[]>> {
        return $api.post<IOverdueTask[]>('/statistics/getOverdueTasks', body);
    }
    static async reportTasksStatus(body: IStatisticsRequest): Promise<AxiosResponse<IPieChartPart[]>> {
        return $api.post<IPieChartPart[]>('/statistics/getTasksStatus', body);
    }
    static async getStatisticsData(body: IGetStatisticsData): Promise<AxiosResponse<IProjectProgressInfo>> {
        return $api.post<IProjectProgressInfo>('/Project/getStatisticData', body);
    }

    static async getTestData(body: IStatisticsRequest): Promise<AxiosResponse<IGetTaskData[]>> {
        return $api.post<IGetTaskData[]>('/statistics/getTestData', body);
    }
}